import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GenericStatusLoading from 'components/GenericStatusLoading'
import ErrorScreen from 'components/ErrorScreen'
import styles from './styles.scss'
import { checkAddress } from './actions'
import {
  API_RESPONSE_NOT_FOUND,
  API_RESPONSE_CONTACT_US,
  API_RESPONSE_NOT_AVAILABLE,
} from './constants'

class AddressCheckStage extends PureComponent {
  static propTypes = {
    // From redux
    result: PropTypes.string,
    avaiabilityDate: PropTypes.string,
    isLoading: PropTypes.bool,
    queued: PropTypes.bool,

    // From Wagtail
    phoneNumber: PropTypes.string,
    notFoundMessage: PropTypes.string,
    notServiceableMessage: PropTypes.string,
    notServiceableYetMessage: PropTypes.string,
    itsComplicatedMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    estimatedDateTitle: PropTypes.string,
    loadingMessage: PropTypes.string,
    queuedMessage: PropTypes.string,

    // Redux functions
    checkAddress: PropTypes.func,
  }

  static defaultProps = {
    result: '',
    avaiabilityDate: null,
    isLoading: true,
    queued: false,
    phoneNumber: undefined,
    notFoundMessage: '<h2>Address not found</h2>' +
      '<p>Unfortunately, we can\'t find your address in our database. ' +
      'Please try another address or call us on the number below to find out if ' +
      'we can service your address.</p>',
    notServiceableMessage: '<h2>Not Serviceable Yet</h2>' +
      '<p>Unfortunately, Kogan Internet is not available in your area yet. We\'ve ' +
      'saved your details and will let you know when it\'s available</p>',
    notServiceableYetMessage: '<h2>Not Serviceable Yet</h2>' +
      '<p>Unfortunately, Kogan Internet is not available in your area yet. We\'ve ' +
      'saved your details and will let you know when it\'s available</p>',
    itsComplicatedMessage: '<h2>It\'s Complicated...</h2>' +
      '<p>That address is in a bit of a tricky situation. Call us on the number ' +
      'below to find out if we can service your address.</p>',
    errorMessage: '<h2>Something went wrong...</h2>' +
      '<p>We are having issues validating your address. Please check your address ' +
      'and try again or if the issue persists, please contact customer service on ' +
      'the number below.</p>',
    estimatedDateTitle: 'Estimated Rollout Date',
    loadingMessage: '<h3>Checking your Addresses</h3><h3>Please wait while we search</h3>',
    queuedMessage: '',
    checkAddress: f => f,
  }

  componentDidMount() {
    if (!this.props.result) {
      this.props.checkAddress()
    }
  }

  render() {
    const {
      result,
      avaiabilityDate,
      isLoading,
      queued,
      phoneNumber,
      notFoundMessage,
      notServiceableMessage,
      notServiceableYetMessage,
      itsComplicatedMessage,
      errorMessage,
      loadingMessage,
      queuedMessage,
      estimatedDateTitle,
    } = this.props

    if (isLoading) {
      return (
        <div className={styles.loadingWrapper}>
          <GenericStatusLoading extraClassName={styles.loader} />
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: loadingMessage }}
          />
          {queued &&
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: queuedMessage }}
            />
          }
        </div>
      )
    }

    if (result === API_RESPONSE_NOT_FOUND) {
      return (
        <ErrorScreen
          text={notFoundMessage}
          textClass={styles.headingAddressNotFound}
          linkTarget="/"
          linkText="Try Another Address"
        />
      )
    }
    if (result === API_RESPONSE_NOT_AVAILABLE) {
      if (avaiabilityDate) {
        return (
          <ErrorScreen
            text={notServiceableYetMessage}
            textClass={styles.headingNbnNotAvailable}
            linkTarget="/"
            linkText="Try Another Address"
          >
            <div className={styles.date}>
              <span>{estimatedDateTitle}</span>
              <h2 className={styles.dateHeading}>{avaiabilityDate}</h2>
            </div>
          </ErrorScreen>
        )
      }
      return (
        <ErrorScreen
          text={notServiceableMessage}
          textClass={styles.headingNbnNotAvailable}
          linkTarget="/"
          linkText="Try Another Address"
        />
      )
    }
    if (result === API_RESPONSE_CONTACT_US) {
      return (
        <ErrorScreen
          text={itsComplicatedMessage}
          textClass={styles.headingContactUs}
          phoneNumber={phoneNumber}
          linkTarget="/"
          linkText="Try Another Address"
        />
      )
    }

    // Something went wrong...
    return (
      <ErrorScreen text={errorMessage} />
    )
  }
}

function mapStateToProps(state) {
  return {
    result: state.checkoutReducer.addressResult,
    avaiabilityDate: state.checkoutReducer.addressAvailabilityDate,
    queued: state.checkoutReducer.addressTaskQueued,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ checkAddress }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressCheckStage)



// WEBPACK FOOTER //
// ./containers/stages/AddressCheckStage/index.jsx